import { Injectable } from "@angular/core";
import { ConsumerService } from "../../shared/services/consumer.service";
import { WebServices } from "../../shared/models/enum/web-services.enum";
import { Observable, Subject } from "rxjs";
import { Response } from "../../shared/models/response";
import { Country } from "../../shared/models/country";
import { takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ObsicashService {
  baseUrl: any = environment.apiUrl + 'otc/'
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private consumerService: ConsumerService) { }

  getCountries(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_COUNTRIES.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getWalletObsicash(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_WALLET.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getAllWalletObsicash(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_LIST_WALLET.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  updateAlias(param): Observable<Response> {
    return this.consumerService
      .post(environment.jweUrls.URL_GET_OBSICASH_WALLET_ALIAS, param)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getHistory(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_HISTORY_TRANSACCION.url)
      .pipe(takeUntil(this.unsubscribe$));
  }
  
  getMovementsDidi(req): Observable<Response> {
    return this.consumerService
      .post(environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_DIDI_MOVEMENTS, req)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getUserObsicashBalance(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_USER_BALANCE.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getInfoUserVerification() {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_PROFILE_VERIFICATION.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  obsicashEnabled(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_ENABLED_OBSICASH.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  generateOTP(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_ONBOARDING_GENERATE_OTP.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getReasonHistory(project: number) {
    return this.consumerService.get(
      environment.jweUrls.URL_GET_OBSICASH_PURPOSE_WITHDRAWAL.url + project
    );
  }

  sendApproveReason(req): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_APPROVE_REASON,
      req
    );
  }
  verificationsGlobal(req): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_VERIFICATIONS_GLOBAL,
      req
    );
  }
  getBlueBankGlobal(request: string): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_BLUEBANK_GLOBAL,
      request
    );
  }
  sendUploadFiles(req): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_UPLOADFILE,
      req
    );
  }

  deleteFile(req): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_DELETEFILE,
      req
    );
  }

  getCurrenciesAllProject(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_OBSICASH_BLUEBANK_GLOBALCURRENCIES.url)
      .pipe(takeUntil(this.unsubscribe$));
  }

  getOnboardingDocuments(request, lng): Observable<Response> {
    return this.consumerService.get(
      environment.jweUrls.URL_GET_ONBOARDING_BLUEBANK_DOCUMENTS.url,
      "?bankId=" +
      request.bankId +
      "&projectId=" +
      request.projectId +
      "&status=0",
      "NA",
      lng
    );
  }
  getFiatAccountList(req, lng): Observable<Response> {
    return this.consumerService.get(
      environment.jweUrls.URL_POST_OBSICASH_GET_COIN_LIST.url,
      "?currency=" + req.currency,
      "NA",
      lng
    ).pipe(takeUntil(this.unsubscribe$));
  }

  uploadFilesP2P(req): Observable<Response> {

    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_UPLOADFILETRUST,
      req
    );
  }
  getDirectorryFile(): Observable<Response> {
    return this.consumerService
      .get(environment.jweUrls.URL_GET_DIRECTORY_P2P.url)
      .pipe(takeUntil(this.unsubscribe$));
  }
  deleteFileP2P(req): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_DIRECTORY_DELETEFILE,
      req
    );
  }

  loginDidi(): Observable<Response> {
    let urlBase = '/obsidiam-api/obsicash-service/v1/didi/didiLogin';
    return this.consumerService.get(urlBase)
  }

  getAdditionalDataDidi(): Observable<Response> {

    return this.consumerService
      .get('/obsidiam-api/obsicash-service/v1/didi/didiGetForms')
      .pipe(takeUntil(this.unsubscribe$));
  }

  getAccountInfoDidi(): Observable<Response> {
    return this.consumerService.get(environment.jweUrls.URL_POST_DIDI_ACCOUNT_INFO.url).pipe(takeUntil(this.unsubscribe$));
  }

  getdidiKycStatus(): Observable<Response>{
    return this.consumerService.get(environment.jweUrls.URL_GET_OBSICASH_ONBOARDING_DIDI_KYC_STATUS.url);
  }

  generateDidiOTP(req): Observable<Response> {
    return this.consumerService
      .post(environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_GENERATE_DIDI_OTP, req);
  }

  checkedDidiOTP(req): Observable<Response> {
    return this.consumerService
      .post(environment.jweUrls.URL_POST_OBSICASH_DIDI_CHECKED_OTP, req);
  }

  getDidiIbanInfo(req): Observable<Response> {
    return this.consumerService
      .post(environment.jweUrls.URL_POST_OBSICASH_DIDI_IBAN_INFO, req);
  }
  getDidiICashOut(req): Observable<Response> {
    return this.consumerService
      .post(environment.jweUrls.URL_POST_OBSICASH_DIDI_CASHOUT, req);
  }
  allCommissionsConfig(): Observable<Response> {
    return this.consumerService.get(
      environment.jweUrls.URL_GET_OBSICASH_ALLCOMMISSIONSCONFIG.url
    );
  }

  getAchTransactionTypes(): Observable<Response> {
    return this.consumerService.get(environment.jweUrls.URL_GET_ACH_GET_TRANSACTION_TYPES.url );
  }

  getAchBanks():Observable<Response> {
    return this.consumerService.get( environment.jweUrls.URL_GET_ACH_GET_BANKS.url );
  }
  createAccountAch(req): Observable<Response> {
    return this.consumerService.post(environment.jweUrls.URL_POST_CREATE_ACH_ASSOCIATE_ACCOUNT,req)
  }
  getAchAccountsAssociates() : Observable<Response> {
    return this.consumerService.get( environment.jweUrls.URL_GET_ACH_ASSOCIATED_ACCOUNT.url);
  }
  getDocumentType() : Observable<Response>{
    return this.consumerService.get( environment.jweUrls.URL_GET_DOCUMENT_TYPE.url );
  }
}
